import React from "react";
import { cx } from "utils/join-classnames";
import { Modal, FormElement } from "ui/components";
import { useFormValidation } from "ui/hooks/use-form-validation";
import styles from "./RequestLivestreamModal.module.scss";

interface Props {
    onAdd(message: string): void;
    onClose(): void;
}

const RequestLivestreamModal: React.FC<Props> = ({ onAdd, onClose }: Props) => {
    const [isSendingRequest, setIsSendingRequest] =
        React.useState<boolean>(false);

    const theForm = useFormValidation({
        message: {
            valid: false,
            touched: false,
            title: "Message",
            value: "",
            errorMsg: "",
            rules: {
                required: true,
                minLength: 2,
            },
        },
    });
    const handleAdd = () => {
        setIsSendingRequest(true);
        onAdd(theForm.formState.message.value?.toString() || "");
    };
    const modalContent = (
        <div className={styles.container}>
            <div className={cx(styles.formelement, styles.infotext)}>
                Tell us about your livestream and we will get back to you.
            </div>
            <FormElement
                type="textarea"
                theme="dark"
                title={theForm.formState.message.title || ""}
                id="requestLivestreamMessage"
                onChange={(value) => {
                    theForm.inputChangeHandler("message", value);
                }}
                defaultText="Your message"
                fieldState={theForm.formState.message}
            />
        </div>
    );
    return (
        <Modal
            content={modalContent}
            lineColor="amber"
            theme="dark"
            onSave={handleAdd}
            onClose={onClose}
            saveButtonDisabled={!theForm.formValid || isSendingRequest}
            saveButtonText="Send Request"
            title="Request livestream"
            icon="plus"
            takeContentSize
        />
    );
};

export default RequestLivestreamModal;
